// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2irpo","validationTips":"StatementDescriptor_validationTips__1vLEK"};